// Player-resource intent builders (server-authoritative resources, P4). Each
// returns a { domain:'resource', kind, seat, amount } object the server's
// match:intent handler routes into resourceService. Keep payload shapes in
// lockstep with valkenhall-server/src/match/resourceService.js.
//
// These carry only AUTOMATED resource flows (engine-driven costs, replenish,
// damage). MANUAL mana/life nudges stay direct absolute SET_MANA / SET_LIFE
// commands the server applies verbatim. Never synthesise an intent from a HUD
// nudge (see valkenhall-server/src/match/resourcePolicy.js).

export function payManaIntent(seat, amount) {
  return { domain: 'resource', kind: 'payMana', seat, amount };
}

export function grantManaIntent(seat, amount) {
  return { domain: 'resource', kind: 'grantMana', seat, amount };
}

export function loseLifeIntent(seat, amount) {
  return { domain: 'resource', kind: 'loseLife', seat, amount };
}

export function gainLifeIntent(seat, amount) {
  return { domain: 'resource', kind: 'gainLife', seat, amount };
}

// Direct Avatar damage. The only non-combat resource intent that can death-blow
// (the server owns the terminal decision via the synced death's-door predicate).
export function dealAvatarDamageIntent(seat, amount) {
  return { domain: 'resource', kind: 'dealAvatarDamage', seat, amount };
}
